import { render, staticRenderFns } from "./ButtonL.vue?vue&type=template&id=06257605&"
import script from "./ButtonL.vue?vue&type=script&lang=js&"
export * from "./ButtonL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports